import {
    getCurrentDate,
    getValidDate
} from "@taabl/common-lib/calculators/date";
const moment = require('moment');

export function getNearestPeriod(periods) {
    let currentDate = getCurrentDate(false);
    let dateDiffArray = [];
    periods.map((period) => {
        let period_startdate = getValidDate(period.periodStartdate);
        dateDiffArray.push(
            Math.abs(currentDate.diff(period_startdate, "days"))
        );
        return period;
    });
    const nearestPeriod = dateDiffArray.indexOf(
        dateDiffArray.reduce((a, b) => Math.min(a, b))
    );
    return {
        currentPeriod: periods[nearestPeriod],
        currentTranche: nearestPeriod
    };
}

export function getCurrentPeriod(periods) {
    if (!periods || periods.length === 0) {
        return null;
    }
    let currentDate = getCurrentDate(false);
    let response = null,
        i = 0;
    for (let period of periods) {
        let sDate = getValidDate(period.periodStartdate);
        let eDate = getValidDate(period.periodEnddate);
        if (currentDate.isBetween(sDate, eDate)) {
            response = {
                period: Object.assign(period),
                index: i
            }
        }
        i++;
    }
    return response;
}

export function findCurrentTranche(startDate, currentPeriod, purchasePeriod, totalTranche) {
    console.log('findCurrentTranche', startDate, currentPeriod, purchasePeriod, totalTranche);
    let currentTranche = 0;
    for (let i = 0; i < totalTranche; i++) {
        let offerStartdate = moment
            .utc(startDate)
            .add(purchasePeriod * i, "months");
        if (
            currentPeriod.periodStartdate >=
            offerStartdate.startOf("day").valueOf() &&
            currentPeriod.periodStartdate < offerStartdate.endOf("day").valueOf()
        ) {
            currentTranche = i;
            break;
        }
    }
    return currentTranche;
}

export function getDefaultPeriodSelection(periods) {
    if (!periods || periods.length === 0) {
        return null;
    }
    let periodResponse = getCurrentPeriod(periods);
    if (periodResponse) {
        return {
            currentPeriod: periodResponse.period,
            currentTranche: periodResponse.index
        }
    } else {
        return getNearestPeriod(periods);
    }
}


export function calculateTotalTranche(plan) {
    return Number(plan.lookBack) / Number(plan.purchasePeriod);
}
